import { createContext } from 'react';

const InitialState = {
  drawerSnackbar: {
    isOpen: false,
    message: '',
  },
  globalSnackbar: {
    isOpen: false,
    message: '',
  },

  hasWorkspaceError: false,
};

const actionTypes = {
  CLOSE_DRAWER_SNACKBAR: 'CLOSE_DRAWER_SNACKBAR',
  CLOSE_GLOBAL_SNACKBAR: 'CLOSE_GLOBAL_SNACKBAR',
  SHOW_DRAWER_SNACKBAR: 'SHOW_DRAWER_SNACKBAR',
  SHOW_GLOBAL_SNACKBAR: 'SHOW_GLOBAL_SNACKBAR',
  WORKSPACE_ERROR: 'WORKSPACE_ERROR',
};

const RootContext = createContext(InitialState);

export { RootContext };
export { InitialState };
export { actionTypes };
